import AXIOS from "../services/axios";

export const getStateList = async () => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/state`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const getProjectList = async (name = null) => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/project${name ? `/?name=${name}` : ""}`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const getPropertyList = async (proj) => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/property/?${proj.length ? `project_id=[${proj}]`: ""}`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const getUserRoleList = async () => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/roles`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const getAccessList = async (token) => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/access`,
    );
    response.result = data;
  } catch (err) {
    response.err = err?.response ?? err;
  }
  return response;
};



